import { deleteDB } from 'idb';

async function deleteDatabase(db: string) {
  try {
    console.log('[clearUserData] Deleting indexedDB database', db);
    await deleteDB(db, {
      blocked: (currentVersion, event) => {
        console.log('Blocked by version and event', currentVersion, event);
        throw new Error('Delete database is blocked');
      },
    });
    console.log('[clearUserData] Deleted indexedDB database', db);
  } catch (error) {
    console.error(`[clearUserData] Failed to delete database ${db}:`, error);
  }
}

async function clearUserData(): Promise<void> {
  try {
    // idb doesn't have an equivilant
    const dbs = await window.indexedDB.databases();
    const deletePromises = dbs
      .filter((db) => {
        return db.name?.toLocaleLowerCase().startsWith('onebrief_');
      })
      .map(async (db) => {
        return deleteDatabase(db.name!);
      });

    await Promise.all(deletePromises);

    // We don't want to clear all of localstorage, since it could be a shared domain.
    // Ideally we prefix all our keys, or we stop sharing a domain.
    const keyPrefixes = [
      'amendState',
      'export_import',
      'c2_',
      'card_list_',
      // 'comments.resolutionStatusFilter',
      'executiveReport.options',
      'file_',
      'layerOrder',
      'libWindowRects-',
      'mapExplorer',
      // 'mapState.pixelRatio
      'my_plans_snapshot_expanded_',
      'navbar.sections.expanded',
      'order_',
      'recentVisits.v1',
      // 'showSyncedArtifactsToggle',
      'timeline.v2',
      'userPlanOverview.options',
      'whiteboards-',
    ];
    Object.keys(localStorage).forEach((key) => {
      keyPrefixes.forEach((prefix) => {
        if (key.startsWith(prefix)) {
          localStorage.removeItem(key);
        }
      });
    });
  } catch (error) {
    console.error('Failed to clear user data', error);
  }
}

export { clearUserData };
